import './index.css'

const Section = ({ title = '',className='', children }) => {
    return (
        <fieldset className={`Section rounded ${className}`}>
            <legend>{title}</legend>
            {children}
        </fieldset>
    )
}

export default Section